function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M77.9 42.5H44.5L56.7 0 0 70.9h33.4l-12.1 42.5zM253.6 96.3c-7.8-15.6-23.7-25.4-41.1-25.4H99.3c-17.4 0-33.4 9.9-41.1 25.5l-22.8 45.3v127.6H85v-28.4h141.8v28.4h49.6V142.1l-22.8-45.8zM63.8 155.9H248v56.7H63.8v-56.7zM83.6 109c2.9-6.1 9-9.9 15.7-9.8h113.2c6.7 0 12.7 3.7 15.7 9.7l9.3 18.6H74.3l9.3-18.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.3 170.1H78v14.2c0 7.8 6.3 14.2 14.2 14.2h28.3v-14.2c0-7.9-6.3-14.2-14.2-14.2zM191.3 184.2v14.2h28.4c7.8 0 14.2-6.3 14.2-14.2V170h-28.4c-7.8.1-14.2 6.4-14.2 14.2z"
})));